import React from 'react'
import { BrowserSearchField } from 'storfox-query-builder'

import * as API from '~/constants/api'

function ChannelField (props) {
  return (
    <BrowserSearchField
      api={API.AUTOMATION_RULE_CHANNEL_LIST}
      {...props}
    />
  )
}

export default ChannelField
